import * as React from 'react';
import { resolve } from "inversify-react";
import autobind from "autobind-decorator";

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { DialogService } from "src/core/services/ui/dialog.service";
import { CacheListView } from "./cache-result-list.view";
import CacheStoreService from 'src/app/general/cache/cache-store.service';
import { SearchType } from 'src/app/products/contractSimulator/parts/pax-occupancy.view';


interface IState {
	data: any;
	pageSize: number;
	pageIndex: number;
	total: number;
	searchType: SearchType;
	loading: boolean;
	totalEntries: number;
	metadata: any;
}

export class CacheListController extends React.Component<ControllerProps<any>, IState> {
	
	@resolve
	protected dialogService: DialogService;

	@resolve
	protected cacheStoreService: CacheStoreService;

	@resolve
	protected toast: ToastNotifications;

	public constructor(props) {
		super(props);

		this.state = {
			data: null,
			pageIndex: 0,
			pageSize: 100,
			total: 0,
			loading: false,
			totalEntries: 0,
			searchType: 'Accommodation',
			metadata: {
				
			}
		};
	}
	


	onFlush = () => {
		this.setState({ loading: true });
		this.cacheStoreService.flushCache().then(result => {
			this.setState({ loading: false });
			this.onSearch({}, this.state.searchType, this.state.pageIndex, this.state.pageSize);
			this.onLoadMetadata();

		}).catch(error => {
			this.setState({ loading: false });
			});

	}
	
	onSearch = (query:any,  type: SearchType, pageIndex: number, pageSize: number) => {

		this.setState({ loading: true, data: null });

		this.cacheStoreService.getGenericStore(query, pageSize, pageIndex, type).then(result => {
			this.setState({ data: result.items, totalEntries: result.total, searchType: type, pageSize: result.pageSize, pageIndex: result.pageIndex, total: result.total, loading: false });
		})
		.catch(error =>
			this.setState({loading: false, data: null})
		);
	}

	onLoadMetadata = async () => {
		var data = await this.cacheStoreService.getMetadata()

	    this.setState({metadata: data});
	}

	public render() {
		return <CacheListView
			total={this.state.total}
			pageIndex={this.state.pageIndex}
			pageSize={this.state.pageSize}
			onSearch={this.onSearch}
			data={this.state.data}
			onFlush={this.onFlush}
			metadata={this.state.metadata}
			onLoadMetadata={this.onLoadMetadata}
			loading={this.state.loading}
			{...this.props } />
	}
}



// WEBPACK FOOTER //
// ./src/app/general/cache/cache-result-list.controller.tsx